
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPaletteDay as ObiPaletteDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-palette-day.js';
 
 
 

 
 export const ObiPaletteDay = createComponent({
   react: React,
   tagName: 'obi-palette-day',
   elementClass: ObiPaletteDayElement,
   events: {
     
   }
  });
 
 